import { createTextVNode as _createTextVNode, createVNode as _createVNode2, resolveComponent as _resolveComponent2 } from "vue";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-9a530c7e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "travel_price"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "scrollPoint"
}, null, -1));

import { ref, reactive, nextTick, cloneVNode } from "vue";
import TravelPriceOperate from "./TravelPriceOperate.vue";
import PriceCalendar from "../setMeal/PriceCalendar.vue";
import msg from "@ui/message";
export default {
  __name: 'TravelPrice',

  setup(__props, {
    expose: __expose
  }) {
    const readOnly = ref(false);
    const tableRef = ref(null);
    const calendarNumber = ref(localStorage.getItem("calendarNumber") || 6);
    const priceOperateRef = ref(null);
    const calendarRef = ref(null);
    var travelPriceDate = ref([]);
    const travelPriceColumns = [{
      key: "travelDate",
      dataKey: "travelDate",
      title: "日期",
      width: 140
    }, {
      key: "groupPeopleNum",
      dataKey: "groupPeopleNum",
      title: "最低成团人数",
      width: 130,
      cellRenderer: data => _createVNode2(_resolveComponent2("el-input"), {
        "type": "number",
        "modelValue": data.rowData.groupPeopleNum,
        "onUpdate:modelValue": $event => data.rowData.groupPeopleNum = $event
      }, null)
    }, {
      key: "expectPeopleNum",
      dataKey: "expectPeopleNum",
      title: "计划预收位",
      width: 130,
      cellRenderer: data => _createVNode2(_resolveComponent2("el-input"), {
        "type": "number",
        "modelValue": data.rowData.expectPeopleNum,
        "onUpdate:modelValue": $event => data.rowData.expectPeopleNum = $event
      }, null)
    }, {
      key: "packagePeopleNum",
      dataKey: "packagePeopleNum",
      title: "最低预定人数",
      width: 130,
      cellRenderer: data => _createVNode2(_resolveComponent2("el-input"), {
        "type": "number",
        "modelValue": data.rowData.packagePeopleNum,
        "onUpdate:modelValue": $event => data.rowData.packagePeopleNum = $event
      }, null)
    }, {
      key: "orderPeopleNum",
      dataKey: "orderPeopleNum",
      title: "最大预定人数",
      width: 130,
      cellRenderer: data => _createVNode2(_resolveComponent2("el-input"), {
        "type": "number",
        "modelValue": data.rowData.orderPeopleNum,
        "onUpdate:modelValue": $event => data.rowData.orderPeopleNum = $event
      }, null)
    }, {
      key: "stockNum",
      dataKey: "stockNum",
      title: "库存",
      width: 120,
      cellRenderer: data => _createVNode2(_resolveComponent2("el-input"), {
        "type": "number",
        "modelValue": data.rowData.stockNum,
        "onUpdate:modelValue": $event => data.rowData.stockNum = $event
      }, null)
    }, {
      key: "del",
      dataKey: "del",
      title: "操作",
      width: 100,
      cellRenderer: data => _createVNode2(_resolveComponent2("el-button"), {
        "type": "danger",
        "onClick": priceDelete.bind(this, data.rowData, data.rowIndex)
      }, {
        default: () => [_createTextVNode("\u5220\u9664")]
      })
    }];

    function calendarSwitch(val) {
      if (val) {
        calendarNumber.value = 6;
        localStorage.setItem("calendarNumber", 6);
      } else {
        calendarNumber.value = 12;
        localStorage.setItem("calendarNumber", 12);
      }

      loadCalendar();
    }

    function formatDate(date) {
      return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    }

    function insertTemplate(date, source, template) {
      for (let index = 0; index < template.length; index++) {
        const element = template[index];
        let data = {
          travelDate: formatDate(date),
          dateSrc: date
        };

        for (const key in element) {
          data[key] = element[key];
        }

        source.push(data);
      }
    }
    /**
     *  添加日期价格
     * 1、检查与原数据日期是否冲突
     * 2、添加数据
     * 3、排序
     */


    function addTravelDate(isDuringCheck, startDate, endDate, week, templateData) {
      if (isDuringCheck) {
        //判断新增日期是否和已编辑日期冲突
        if (isDuringDate(startDate, endDate, week)) {
          msg.error("添加日期价格于现有日期价格冲突");
          return false;
        }
      }

      var prevDate = startDate;
      var dateData = [];

      if (isMeetWeek(startDate, week)) {
        insertTemplate(startDate, dateData, templateData);
      } //构建日期区间


      const day = diffDay(startDate, endDate);

      for (let index = 0; index < day; index++) {
        prevDate = nextDay(prevDate);

        if (isMeetWeek(prevDate, week)) {
          insertTemplate(prevDate, dateData, templateData);
        }
      } //日期合并


      if (travelPriceDate.value.length <= 0) {
        travelPriceDate.value = travelPriceDate.value.concat(dateData);
      } else {
        travelPriceDate.value = travelPriceDate.value.concat(dateData); //排序

        travelPriceDate.value.sort((a, b) => {
          return a.dateSrc - b.dateSrc;
        });
      }

      return true;
    }
    /**
     * 覆盖日期价格
     * 1、原数据中删除需要覆盖的日期
     * 2、添加数据
     * 3、排序
     */


    function coverTravelDate(startDate, endDate, week, templateData) {
      for (var i = travelPriceDate.value.length - 1; i >= 0; i--) {
        let oldDate = travelPriceDate.value[i];

        if (isMeetWeek(oldDate.dateSrc, week) && oldDate.dateSrc >= startDate && oldDate.dateSrc <= endDate) {
          travelPriceDate.value.splice(i, 1);
        }
      }

      addTravelDate(false, startDate, endDate, week, templateData);
    }

    function loadCalendar() {
      nextTick(() => {
        calendarRef.value.setChecked(travelPriceDate.value);
      });
    }

    function isMeetWeek(date, week) {
      return week.includes(date.getDay());
    }

    function isDuringDate(startDate, endDate, week) {
      for (const oldDate of travelPriceDate.value) {
        if (!isMeetWeek(oldDate.dateSrc, week)) {
          continue;
        }

        if (oldDate.dateSrc >= startDate && oldDate.dateSrc <= endDate) {
          return true;
        }
      }

      return false;
    }

    function diffDay(date_1, date_2) {
      let totalDays, diffDate;
      diffDate = Math.abs(date_1 - date_2);
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24));
      return totalDays;
    }

    function nextDay(date) {
      date = new Date(date);
      date = +date + 1000 * 60 * 60 * 24;
      date = new Date(date);
      return date;
    }

    function priceDelete(date, index) {
      travelPriceDate.value.splice(index, date.spacsLength);
      calendarRef.value.setChecked(travelPriceDate.value);
    }

    function checkOperateChange(callback) {
      if (travelPriceDate.value.length <= 0) {
        return callback(true);
      } else {
        return callback(false);
      }
    }

    function calendarDel(data) {
      for (let index = 0; index < travelPriceDate.value.length; index++) {
        const element = travelPriceDate.value[index];

        if (data.year == element.dateSrc.getFullYear() && data.month == element.dateSrc.getMonth() + 1 && data.day == element.dateSrc.getDate()) {
          travelPriceDate.value.splice(index, 1);
          break;
        }
      }
    }

    function calendarSelect(data, callback) {
      const date = new Date(data.year, data.month - 1, data.day);

      if (data.checked) {
        document.getElementById("scrollPoint").scrollIntoView();
        jumpTableDate(date);
        callback(false);
      } else {
        if (priceOperateRef.value.validate()) {
          callback(insertTableDate(date));
        } else {
          callback(false);
        }
      }
    }

    function jumpTableDate(date) {
      for (let index = 0; index < travelPriceDate.value.length; index++) {
        const element = travelPriceDate.value[index];

        if (date.getFullYear() == element.dateSrc.getFullYear() && date.getMonth() == element.dateSrc.getMonth() && date.getDate() == element.dateSrc.getDate()) {
          tableRef.value.scrollToRow(index, "start");
          break;
        }
      }
    }

    function insertTableDate(date) {
      const template = priceOperateRef.value.getOperate().template;
      var isExist = false;

      for (const price of travelPriceDate.value) {
        if (date.getFullYear() == price.dateSrc.getFullYear() && date.getMonth() == price.dateSrc.getMonth() && date.getDate() == price.dateSrc.getDate()) {
          isExist = true;
        }
      }

      if (!isExist) {
        insertTemplate(date, travelPriceDate.value, template);
        travelPriceDate.value.sort((a, b) => {
          return a.dateSrc - b.dateSrc;
        });
        return true;
      }

      return false;
    }

    function execute(data) {
      if (data.operate == "clear") {
        travelPriceDate.value = [];
        loadCalendar();
      } else if (data.operate == "modify") {
        let startDate = new Date(data.date[0]);
        let endDate = new Date(data.date[1]);
        coverTravelDate(startDate, endDate, data.week, data.template);
        loadCalendar();
      } else if (data.operate == "add") {
        let startDate = new Date(data.date[0]);
        let endDate = new Date(data.date[1]);

        if (addTravelDate(true, startDate, endDate, data.week, data.template)) {
          loadCalendar();
        }
      }
    }

    function improtTravelDate(data) {
      const nowDate = new Date(new Date().setHours(0, 0, 0, 0));
      var travelData = [];

      for (const e of data) {
        var handleData = {};
        handleData.dateSrc = new Date(e.travelDate);

        if (handleData.dateSrc < nowDate) {
          continue;
        }

        for (const key in e) {
          if (key != "dateSrc") {
            handleData[key] = e[key];
          }
        }

        travelData.push(handleData);
      }

      travelPriceDate.value = travelData;
    }

    function improtData(data) {
      // priceOperateRef.value.importData(data.packagePriceItems);
      improtTravelDate(data);
      loadCalendar();
    }

    function reset() {
      priceOperateRef.value.resetData();
      travelPriceDate.value = [];
      loadCalendar();
    }

    function chack() {
      return travelPriceDate.value.length > 0;
    }

    function getValue() {
      if (travelPriceDate.value.length > 0) {
        return travelPriceDate.value;
      } else {
        msg.error("请完善参团设置");
        return false;
      }
    }

    __expose({
      improtData,
      reset,
      getValue,
      chack
    });

    return (_ctx, _cache) => {
      const _component_el_table_v2 = _resolveComponent("el-table-v2");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(TravelPriceOperate, {
        ref_key: "priceOperateRef",
        ref: priceOperateRef,
        onExecute: execute,
        onCheckOperateChange: checkOperateChange,
        onCalendarSwitch: calendarSwitch
      }, null, 512), _createVNode(PriceCalendar, {
        ref_key: "calendarRef",
        ref: calendarRef,
        number: calendarNumber.value,
        onSelect: calendarSelect,
        onDel: calendarDel
      }, null, 8, ["number"]), _hoisted_2, _createVNode(_component_el_table_v2, {
        ref_key: "tableRef",
        ref: tableRef,
        columns: travelPriceColumns,
        data: _unref(travelPriceDate),
        width: 850,
        height: 700
      }, {
        empty: _withCtx(() => []),
        _: 1
      }, 8, ["data"])]);
    };
  }

};